import React, { useState } from "react";
import { useTab } from "../../../contexts/tab";
import LabelForm from "../forms/LabelForm";
import DisableEnableLabel from "../forms/DisableEnableLabel";
import classNames from "classnames";
import { disableIcone, editIcon } from "../../icon";
import { format } from "date-fns";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

const validate = (values) => {
  const errors = {};
  return errors;
};

export default function TabBodyLabelSize() {
  const [{ tabData, teethList }, { setTabData, setTeethList }] = useTab();
  const [isOpen, setIsOpen] = useState(false);
  const [labelToEdit, setLabelToEdit] = useState(null);
  const [enableDisableLabel, setEnableDisableLabel] = useState(null);
  const [{ activeUser }] = useAuth();
  function handaleEdit(label) {
    const [width, height] = label?.size?.split("X") || [];
    setLabelToEdit({ ...label, width, height });
    setIsOpen(true);
  }

  function handaleStatus({ id, status, size }) {
    setEnableDisableLabel({ id, status, size });
  }

  async function handleReset() {
    formik.resetForm({
      size: "",
      teeth: "",
      cut: "",
    });

    setTabData(null);
    const restApi = "getLabel";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
        if (data?.teethList) {
          setTeethList(JSON.parse(data.teethList));
        }
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  async function submitFormData(values) {
    // alert(JSON.stringify(values));

    try {
      const res = await fetch(basePath + "getFilteredLabels", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
        if (data?.teethList) {
          setTeethList(JSON.parse(data.teethList));
        }
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      size: "",
      teeth: "",
      cut: "",
    },
    validate,
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  return (
    <div>
      <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
        <form
          className="flex gap-3 items-center"
          onSubmit={formik.handleSubmit}
        >
          <label>
            <span className="mr-3">Search:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.size}
              onChange={formik.handleChange}
              type="text"
              name="size"
              placeholder="Search Size"
            />
          </label>

          <label>
            <span className="mr-3">Cut:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.cut}
              onChange={formik.handleChange}
              type="text"
              name="cut"
              placeholder="Cut"
            />
          </label>

          <label>
            <span className="mr-3">Teeth:</span>
            <select
              className="bg-white p-2 rounded-md"
              name="teeth"
              value={formik.values.teeth}
              onChange={formik.handleChange}
            >
              <option value="">select teeth</option>

              {console.log({ teethList })}
              {teethList &&
                teethList?.map(({ id, teeth }) => (
                  <option key={teeth}>{teeth}</option>
                ))}
            </select>
          </label>

          <button className="bg-white rounded-sm px-2 py-1" type="submit">
            Submit
          </button>
          <button
            onClick={handleReset}
            className="bg-white rounded-sm px-2 py-1"
            type="button"
          >
            Reset
          </button>
        </form>
        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => setIsOpen(true)}
            className="bg-orange text-white p-2 rounded-md "
          >
            Add Label
          </button>
        )}
      </div>

      <LabelForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        labelToEdit={labelToEdit}
        setLabelToEdit={setLabelToEdit}
      />
      <DisableEnableLabel
        enableDisableLabel={enableDisableLabel}
        setEnableDisableLabel={setEnableDisableLabel}
      />
      {tabData && (
        <table className="dataTable">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Size</th>
              <th scope="col">Cut</th>
              <th scope="col">Ups</th>
              <th scope="col">Gap</th>
              <th scope="col">Type</th>
              <th scope="col">Teeth</th>
              <th scope="col">Date</th>
              <th scope="col">Note</th>
              {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tabData.data.map(
              ({
                id,
                size,
                cut,
                ups,
                gap,
                type,
                teeth,
                date,
                note,
                is_disable,
              }) => {
                return (
                  <tr key={id}>
                    <td scope="col">{id}</td>
                    <td scope="col">{size}</td>
                    <td scope="col">{cut}</td>
                    <td scope="col">{ups}</td>
                    <td scope="col">{gap}</td>
                    <td scope="col">{type}</td>
                    <td scope="col">{teeth}</td>
                    <td scope="col">
                      {date && date !== "0000-00-00"
                        ? format(new Date(date), "dd/MM/yyyy")
                        : "--"}
                    </td>
                    <td scope="col">{note}</td>
                    {activeUser?.user_permission <= 2 && (
                      <td scope="col">
                        <button
                          className="bg-green-600 p-2 rounded-md my-1"
                          onClick={() =>
                            handaleEdit({
                              id,
                              size,
                              cut,
                              ups,
                              gap,
                              type,
                              teeth,
                              date,
                              note,
                            })
                          }
                        >
                          {editIcon}
                        </button>
                        <button
                          className={classNames(
                            "p-2 rounded-md ml-2",
                            is_disable ? "bg-blue-700" : "bg-orange"
                          )}
                          onClick={() =>
                            handaleStatus({ id, status: is_disable, size })
                          }
                        >
                          {disableIcone}
                        </button>
                      </td>
                    )}
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      )}
      {!tabData && <ShimmerTable />}
    </div>
  );
}
